module.exports = __webpack_public_path__ + "static/img/5.5e3092a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/5.png
// module id = vd7b
// module chunks = 0